<div class="modal-content">
    <div class="modal-header">
        <h4 class="modal-title">Agregar productos</h4>
        <button type="button" class="close" (click)="cancel()" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <pos-list [data]="products" [filters]="getProductFilters()"
            [config]="{title:'code',description:'description',smallTitleNumber:'total',badge:'stock',hasAction:true}" [itemsPerPage]="5"
            (dataChange)="getProductData($event)" (clickDetail)="showDetailProduct($event)" (rowClick)="productRowClick($event)"></pos-list>
      </div>
</div>
